
import GeoJSON from 'ol/format/GeoJSON';
import { buffer as extentBuffer } from 'ol/extent';

import MapCommand from './MapCommand';

export default class MapCommandHighlightFeature extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'HIGHLIGHT_FEATURE';
    }

    execute(olMap, params) {
        let source = olMap.getHighlightLayer().getSource();
        source.clear();

        let format = new GeoJSON();
        let features = params.geoJsons || [params.geoJson];

        features.forEach(item => {
            source.addFeature(format.readFeature(item));
        });

        if (params.zoomToFeature) {
            if (source.getFeatures().length > 0) {
                let extent = extentBuffer(source.getExtent(), 100);
                olMap.getView().fit(extent);
            }
        }
    }
}
